import React, { useEffect, useState } from "react";

import BankingSearch from "../../../../Components/Search/Banking/BankingSearch";

const Banking_Search = () => {
 
  return (
    <>
     <BankingSearch/>
    </>
  );
};

export default Banking_Search;
